/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-13 16:50:05
 * @FilePath: \hlweb2.0\src\pages\SuccessStories\before-banner\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { useTranslation } from "react-i18next";
import "./index.scss";
function BeforeBanner({changeIsDisabled}) {
  const { t } = useTranslation();
  const successOperations = t("successOperations", {
    returnObjects: true,
  });
  return (
    <div className="success_before-banner_side">
      <div className="success_before-banner_con">
        <div className="before-banner-top">
          {successOperations.beforeContent.top}
        </div>
        <div className="before-banner-til">{successOperations.title}</div>
        <ul className="before-banner-detail">
          {successOperations.beforeContent.bottom.map((item, index) => {
            return (
              <li key={index}>
                <span>{item}</span>
              </li>
            );
          })}
        </ul>
        <div className="before-banner-btn" onClick={() => changeIsDisabled(true)}>
          {successOperations.beforeContent.btn}
        </div>
      </div>
    </div>
  );
}

export default BeforeBanner;
